import addToCart from './addToCart';
import pageView from './pageView';
var Bing = {
  pageview: [pageView],
  'product:addToCart': [addToCart]
};
export default Bing;